import { motion } from "framer-motion";

export function Footer() {
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      className="mt-12 mb-28 px-5"
    >
      <div className="max-w-2xl mx-auto text-center">
        <div className="h-[1px] bg-gradient-to-r from-transparent via-surface-3 to-transparent mb-8" />
        <div className="w-10 h-10 rounded-full bg-kra-soft mx-auto mb-3 flex items-center justify-center">
          <span className="text-kra font-display text-lg">A</span>
        </div>
        <p className="text-sm text-ink-2 leading-relaxed">
          Kimono Rental Ann
        </p>
        <p className="text-xs text-ink-3 mt-1">
          Asakusa, Tokyo
        </p>
      </div>
    </motion.footer>
  );
}
